<div class="outline-surface-300 absolute inset-0 -z-10 outline-3" [class]="twRounded()"></div>

<p
  class="relative py-2 outline-3 transition-colors select-none"
  [class]="tw() + ' ' + twRounded()"
  [attr.role]="isSelectable() ? 'button' : null"
  [attr.tabindex]="isSelectable() ? 0 : null"
  (click)="isSelectable() ? toggleSelection() : undefined"
  (keydown.enter)="isSelectable() ? toggleSelection() : undefined"
  (keydown.space)="$event.preventDefault(); isSelectable() ? toggleSelection() : undefined"
>
  {{ word() }}
</p>
